// Lokales Error-Log — letzte 100 Fehler in IndexedDB (verschlüsselt wo möglich)
// Kein automatisches Tracking (Datenschutz!)

import { db } from '../../db/schema';

export interface ErrorLogEntry {
  id?: number;
  timestamp: string;
  level: 'critical' | 'module' | 'component';
  location: string;       // Modul- oder Komponentenname
  message: string;
  stack?: string | undefined;
  userAgent: string;
}

const MAX_ENTRIES = 100;

export async function logError(entry: Omit<ErrorLogEntry, 'id' | 'timestamp' | 'userAgent'>): Promise<void> {
  try {
    const full: ErrorLogEntry = {
      ...entry,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent.slice(0, 120),
    };

    // In Audit-Log schreiben (immer verfügbar, auch ohne Session-Key)
    await db.audit_log.add({
      schema_version: 1,
      timestamp: full.timestamp,
      firma: 'SYSTEM',
      aktion: `ERROR_${entry.level.toUpperCase()}`,
      details: JSON.stringify({
        location: entry.location,
        message: entry.message.slice(0, 500),
      }),
    });

    // Älteste Einträge bereinigen
    const count = await db.audit_log.count();
    if (count > MAX_ENTRIES) {
      const oldest = await db.audit_log.orderBy('id').limit(count - MAX_ENTRIES).primaryKeys();
      await db.audit_log.bulkDelete(oldest as number[]);
    }
  } catch {
    // Error-Log darf niemals selbst crashen
    console.error('[ErrorLog] Konnte Fehler nicht persistieren');
  }
}

export async function exportErrorLog(): Promise<string> {
  const entries = await db.audit_log
    .where('aktion').startsWith('ERROR_')
    .reverse()
    .limit(100)
    .toArray();

  const anonymized = entries.map(e => ({
    timestamp: e.timestamp,
    aktion: e.aktion,
    details: e.details,
  }));

  return JSON.stringify({ exported_at: new Date().toISOString(), entries: anonymized }, null, 2);
}
